export const MAX_LENGTH_ATTRIBUTE = 50;
